module.exports = __webpack_public_path__ + "assets/cancel.31e91492.svg";